import React from 'react';
import { connect } from 'react-redux';
import { getEquipment } from '../../../redux/selectors/equipment';
import { getBuildingField } from '../../../redux/selectors/buildings';
import { attachDefaultUnits } from '../../../redux/selectors/points';
import { dateTime } from '../../../utils/parsing';
import PointTable from './PointTable';

const getPointRow = (buildingTz) => (p) => ({
  id: p.id,
  values: [
    p.type,
    `${p.name} ${p.description}`,
    p.device,
    `${p.value}`,
    p.units,
    dateTime(p.lastUpdatedTs, buildingTz),
    p.tags
      .concat(p.labels)
      .map((t) => `#${t.name}`)
      .join(', '),
  ],
});

const AssetPointTable = ({ equipment, buildingTz }) => (
  <PointTable variant="asset" points={equipment.points} rowBuilder={getPointRow(buildingTz)} />
);

export default connect((state, { equipmentId }) => {
  const equipment = getEquipment(state, equipmentId);
  const equipmentWithUnits = {
    ...equipment,
    points: attachDefaultUnits(state, equipment.points),
  };
  return {
    buildingTz: getBuildingField(state, equipment.buildingId, 'timezone'),
    equipment: equipmentWithUnits,
  };
})(AssetPointTable);
